import styled from 'styled-components';
import { device } from '../../utilities/sizes.util';


export const CarouselSliderContainer = styled.div`
    width: 100%; /* Set the desired width */
    max-width: ${device.desktop} 
    margin: 0 auto;
`;